/*
 * ============================================================
 * SELLER DASHBOARD — assets/ccs-dashboard.js
 * ============================================================
 * Drives templates/page.store.liquid.
 *
 * The template has already decided which of the three states to paint from the
 * customer metafield, so this fills in figures rather than deciding layout --
 * except where the API disagrees with the metafield, which is the one case
 * worth correcting on screen (a store created while a metafield write failed).
 */
(function (window, document) {
  'use strict';

  var root, api, state = { store: null, listings: [], sales: null };

  function $(selector, scope) { return (scope || document).querySelector(selector); }
  function $$(selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }

  function setText(selector, value) {
    var el = $(selector);
    if (el) el.textContent = value;
  }

  // ── Support impersonation ─────────────────────────────────────────────────

  /*
   * ?as= is carried in the URL so a support session survives a reload and can
   * be shared as a link. The API client holds it for every subsequent call.
   */
  function readActingAs() {
    var params = new URLSearchParams(window.location.search);
    var as = params.get('as');
    if (as) api.actingAs = as;
    return as;
  }

  function renderImpersonation() {
    var banner = $('#ccs-impersonation');
    if (!banner || !api.actor || !api.actor.impersonating) return;
    var target = api.actor.target || {};
    banner.hidden = false;
    setText('#ccs-impersonation [data-ccs="target"]', target.handle || target.email || 'another seller');
    document.body.classList.add('ccs-impersonating');
  }

  // ── Rendering ─────────────────────────────────────────────────────────────

  function renderStore(store) {
    if (!store) return;
    state.store = store;

    setText('[data-ccs="store-name"]', store.name);

    var link = $('[data-ccs="store-link"]');
    if (link) {
      link.href = store.url;
      link.textContent = window.location.host + store.shareUrl;
    }

    var logo = $('.ccs-store-logo');
    if (logo) {
      var img = $('img', logo);
      if (store.logoImageUrl) {
        img.src = store.logoImageUrl;
        img.hidden = false;
        logo.dataset.empty = 'false';
      } else {
        logo.dataset.empty = 'true';
      }
    }

    $('#ccs-register').hidden = true;
    $('#ccs-dashboard-body').hidden = false;
  }

  /*
   * The designs grid.
   *
   * Which designs, and in what order, is the category strip's answer -- on
   * "All items" that is the server's order (categories first, each in its
   * own order, then the unfiled tail), and inside a category it is that
   * category's own. So the dashboard shows what a shopper would see on that
   * tab, which is the only way arranging it is not done blind.
   */
  function renderListings(listings) {
    if (listings) state.listings = listings;
    var host = $('#ccs-listings');
    var template = $('#ccs-listing-card');
    if (!host || !template) return;

    var byUid = {};
    state.listings.forEach(function (listing) { byUid[listing.uid] = listing; });

    // The count is every design in the store, not the open tab: it is a fact
    // about the shop, and it sits beside "owed" and "shirts sold".
    setText('[data-ccs="designs"]', String(state.listings.length));
    host.innerHTML = '';

    if (!state.listings.length) {
      host.innerHTML = '<p class="ccs-empty-note">No designs yet. ' +
        '<a href="/pages/sell?start=1">Create your first one</a>.</p>';
      return;
    }

    var order = window.CCSCategories
      ? window.CCSCategories.visibleUids(state.listings.map(function (l) { return l.uid; }))
      : state.listings.map(function (l) { return l.uid; });

    if (!order.length) {
      host.innerHTML = '<p class="ccs-empty-note">Nothing in this category yet. ' +
        'Use <strong>+ Category</strong> on a design to put it here.</p>';
      return;
    }

    order.forEach(function (uid) {
      var listing = byUid[uid];
      if (!listing) return;
      var card = template.content.firstElementChild.cloneNode(true);
      var link = $('[data-ccs="link"]', card);

      card.dataset.uid = listing.uid;
      // Draggable only where a drag would mean something: inside a category,
      // where the seller is arranging that category's order.
      card.draggable = !!(window.CCSCategories && window.CCSCategories.isOrdering());

      // A listing still publishing has no product page to link to yet.
      if (listing.productUrl) link.href = listing.productUrl;
      else link.removeAttribute('href');

      // The feature photo where there is one, for the same reason the
      // storefront uses it: it is what this design looks like to a shopper,
      // and a seller checking their designs should be seeing what the shop
      // is showing rather than a different picture of the same thing.
      var img = $('img', card);
      img.src = listing.featureImage || listing.frontImageUrl || '';
      img.alt = listing.name;

      $('[data-ccs="name"]', card).textContent = listing.name;
      $('[data-ccs="price"]', card).textContent =
        api.priceRange(listing.minPrice, listing.maxPrice) +
        (listing.markup != null ? '  ·  you make ' + api.money(listing.markup) + '+' : '');

      var badge = $('[data-ccs="status"]', card);
      if (listing.pending) {
        badge.hidden = false;
        badge.textContent = 'Publishing…';
      }

      var swatches = $('[data-ccs="swatches"]', card);
      (listing.colors || []).forEach(function (color) {
        var dot = document.createElement('span');
        dot.className = 'ccs-swatch';
        dot.title = color.name;
        dot.style.background = color.hex ? '#' + String(color.hex).replace(/^#/, '') : '#ccc';
        swatches.appendChild(dot);
      });

      if (window.CCSCategories) window.CCSCategories.decorateCard(card, listing.uid);

      $('[data-ccs="edit"]', card).dataset.uid = listing.uid;
      $('[data-ccs="edit-design"]', card).dataset.uid = listing.uid;
      $('[data-ccs="duplicate"]', card).dataset.uid = listing.uid;
      $('[data-ccs="remove"]', card).dataset.uid = listing.uid;
      host.appendChild(card);
    });
  }

  function renderSales(data) {
    state.sales = data;
    setText('[data-ccs="owed"]', api.money(data.owed || 0));
    setText('[data-ccs="shirts"]', String(data.shirts || 0));

    var body = $('#ccs-sales tbody');
    if (!body) return;
    body.innerHTML = '';

    if (!data.sales || !data.sales.length) {
      body.innerHTML = '<tr><td colspan="9" class="ccs-empty-note">No sales yet.</td></tr>';
      return;
    }

    data.sales.forEach(function (sale) {
      var tr = document.createElement('tr');
      if (sale.cancelled) tr.className = 'is-void';

      var status = sale.cancelled ? 'Cancelled'
        : sale.refunded >= sale.quantity ? 'Refunded'
        : sale.refunded > 0 ? 'Partly refunded'
        : sale.paid ? 'Paid out'
        : 'Pending payout';

      var design = (state.listings.find(function (l) { return l.uid === sale.listingUid; }) || {}).name
        || sale.listingUid || '—';

      [
        sale.orderNumber || '—',
        sale.orderDate ? new Date(sale.orderDate).toLocaleDateString() : '—',
        design,
        [sale.color, sale.size].filter(Boolean).join(' · ') || '—',
        sale.shipTo || '—',
        String(sale.quantity),
        api.money(sale.unitPrice),
        sale.earned == null ? '—' : api.money(sale.earned),
        status
      ].forEach(function (value, index) {
        var td = document.createElement('td');
        if (index >= 5 && index <= 7) td.className = 'num';
        td.textContent = value;
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });
  }

  // ── Actions ───────────────────────────────────────────────────────────────

  function wireListingActions() {
    var host = $('#ccs-listings');
    if (!host) return;

    host.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ccs]');
      if (!button) return;
      var uid = button.dataset.uid;
      var listing = state.listings.find(function (l) { return l.uid === uid; });
      if (!listing) return;

      if (button.getAttribute('data-ccs') === 'remove') {
        // Removing takes the product off the storefront; orders already placed
        // are unaffected, and saying so here avoids a support question.
        if (!window.confirm('Remove "' + listing.name + '" from your store?\n\n' +
            'It will no longer be for sale. Orders already placed are not affected.')) return;
        button.disabled = true;
        api.deleteListing(uid).then(function () {
          renderListings(state.listings.filter(function (l) { return l.uid !== uid; }));
        }).catch(function (error) {
          button.disabled = false;
          window.alert(error.message);
        });
      }

      if (button.getAttribute('data-ccs') === 'edit-design') {
        // Reopens the builder on this listing. Saving writes over it rather
        // than making a second one -- see ?edit= in ccs-builder-host.js.
        window.location.assign('/pages/design?edit=' + encodeURIComponent(uid));
      }

      if (button.getAttribute('data-ccs') === 'duplicate') {
        // Nothing is copied here. The builder opens on the listing and the
        // seller publishes the copy themselves, so a duplicate they change
        // their mind about costs them a Close rather than a Remove.
        window.location.assign('/pages/design?from=' + encodeURIComponent(uid));
      }

      if (button.getAttribute('data-ccs') === 'edit') openEdit(listing);
    });
  }

  // ── Editing a published design ────────────────────────────────────────────
  //
  // Name, description and margin. Not artwork, colors or sizes: those mean
  // new print files and new variants, which is a run through the builder.
  // Duplicate is how that is done without disturbing a design already selling.

  var editing = null;
  var editQuoteToken = 0;

  function editMarkup() {
    var slider = $('#ccs-edit-markup');
    return slider ? Number(slider.value) : 3;
  }

  /*
   * What shoppers would pay at this margin.
   *
   * Quoted rather than worked out here: the same call the builder makes, so
   * the number on this screen and the number on the product come from one
   * place. The listing's own colors and sizes describe what to price.
   */
  function refreshEditQuote() {
    var value = $('[data-ccs="edit-markup-value"]');
    var range = $('[data-ccs="edit-quote"]');
    if (value) value.textContent = api.money(editMarkup());
    if (!range || !editing) return;

    var token = ++editQuoteToken;
    range.textContent = '…';
    api.quote({
      sourceStyleHandle: editing.sourceStyleHandle,
      markup: editMarkup(),
      colors: (editing.colors || []).map(function (color) {
        return {
          key: color.key,
          sizes: (color.sizes || []).map(function (size) { return size.name; })
        };
      })
    }).then(function (data) {
      if (token !== editQuoteToken) return;   // a newer drag has overtaken this
      range.textContent = api.priceRange(data.minPrice, data.maxPrice);
    }).catch(function () {
      if (token !== editQuoteToken) return;
      range.textContent = '—';
    });
  }

  // Which color the product page opens on. Held while the dialog is open and
  // sent with the save, rather than written on each click -- a seller trying
  // colors out has not decided until they press Save.
  var editDefaultColor = null;

  function renderEditColors() {
    var host = $('[data-ccs="edit-colors"]');
    if (!host || !editing) return;
    host.textContent = '';
    (editing.colors || []).forEach(function (color) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ccs-default-swatch' +
        (color.key === editDefaultColor ? ' is-on' : '');
      button.dataset.ccs = 'edit-default-color';
      button.dataset.color = color.key;
      button.title = color.name;
      button.setAttribute('aria-label', color.name);
      button.setAttribute('aria-pressed', color.key === editDefaultColor ? 'true' : 'false');
      button.style.background = color.hex
        ? '#' + String(color.hex).replace(/^#/, '')
        : '#ccc';
      host.appendChild(button);
    });
  }

  function openEdit(listing) {
    editing = listing;
    // Fall back the same way the server does, so the dialog shows what the
    // shop is actually doing rather than nothing at all.
    editDefaultColor = listing.defaultColorKey ||
      ((listing.colors || [])[0] || {}).key || null;
    $('#ccs-edit-name').value = listing.name || '';
    $('#ccs-edit-desc').value = listing.description || '';
    $('#ccs-edit-markup').value = String(listing.markup == null ? 3 : listing.markup);
    showError($('[data-ccs="edit-error"]'), '');
    renderEditColors();
    openModal('#ccs-edit-listing-modal');
    refreshEditQuote();
  }

  function showError(element, text) {
    if (!element) return;
    element.textContent = text || '';
    element.hidden = !text;
  }

  function saveEdit(button) {
    if (!editing) return;
    var error = $('[data-ccs="edit-error"]');
    var name = $('#ccs-edit-name').value.trim();
    if (!name) {
      showError(error, 'Give your design a name.');
      $('#ccs-edit-name').focus();
      return;
    }

    showError(error, '');
    button.disabled = true;
    api.updateListing({
      uid: editing.uid,
      name: name,
      description: $('#ccs-edit-desc').value.trim(),
      markup: editMarkup(),
      defaultColorKey: editDefaultColor || ''
    }).then(function (data) {
      button.disabled = false;
      closeModal();
      // Repriced on the server, so the card is repainted from what came back
      // rather than from what was typed.
      if (data && data.listing) {
        renderListings(state.listings.map(function (l) {
          return l.uid === data.listing.uid ? data.listing : l;
        }));
      }
    }).catch(function (err) {
      button.disabled = false;
      showError(error, err.message);
    });
  }

  // ── Starting a new design ─────────────────────────────────────────────────

  var WIZARD_URL = '/pages/sell?start=1';

  /*
   * The garments this seller has already published on, most recent first.
   *
   * Keyed on the SIB style handle, so three designs on the same blank offer
   * it once. Listings arrive newest first, which makes first-seen the right
   * order to show them in without sorting.
   */
  function usedStyles() {
    var seen = {};
    var out = [];
    state.listings.forEach(function (listing) {
      var handle = listing.sourceStyleHandle;
      if (!handle) return;
      if (seen[handle]) { seen[handle].count += 1; return; }
      seen[handle] = { handle: handle, title: listing.sourceStyleTitle || handle, count: 1 };
      out.push(seen[handle]);
    });
    return out;
  }

  /*
   * A clean shot of the blank, not one of the seller's designs on it.
   *
   * quote() already caches the SIB style feed server-side and returns the
   * style's title and image alongside the price, which is why the shirt
   * picker uses it for the same purpose. One request per distinct garment,
   * and a failure just leaves the card with its stored title and no picture.
   */
  function fillStyleCard(card, style) {
    api.quote({ sourceStyleHandle: style.handle }).then(function (data) {
      var info = data && data.style;
      if (!info) return;
      if (info.title) $('[data-ccs="title"]', card).textContent = info.title;
      if (info.image) $('[data-ccs="img"]', card).src = info.image;
    }).catch(function () {});
  }

  function openNewDesign() {
    var styles = usedStyles();
    // Nothing published yet, so there is nothing to offer and the dialog would
    // be a single button. Straight to the wizard.
    if (!styles.length) { window.location.assign(WIZARD_URL); return; }

    var grid = $('[data-ccs="style-grid"]');
    var template = document.getElementById('ccs-style-card');
    if (!grid || !template) { window.location.assign(WIZARD_URL); return; }

    grid.textContent = '';
    styles.forEach(function (style) {
      var card = template.content.firstElementChild.cloneNode(true);
      card.dataset.handle = style.handle;
      $('[data-ccs="title"]', card).textContent = style.title;
      $('[data-ccs="used"]', card).textContent =
        style.count + (style.count === 1 ? ' design' : ' designs');
      grid.appendChild(card);
      fillStyleCard(card, style);
    });

    openModal('#ccs-new-design-modal');
  }

  function openModal(selector) {
    var modal = $(selector);
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ccs-modal-open');
  }

  function closeModal() {
    var modal = document.querySelector('.ccs-modal-root:not([hidden])');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ccs-modal-open');
  }

  /*
   * The data-ccs values that DO something, as opposed to the ones naming a
   * slot something is written into.
   *
   * A click lands on whatever is under the pointer, so closest('[data-ccs]')
   * finds the nearest hook of any kind. A style card is a button with the
   * shirt photo and its name inside it carrying slots -- so clicking the
   * photo found data-ccs="img" and the card did nothing. Only its padding
   * worked. Same shape of bug as the color rail and the category tabs.
   */
  var ACTIONS = [
    'add-design', 'find-style', 'pick-style', 'close-modal',
    'edit-default-color', 'save-listing'
  ];
  var ACTION_SELECTOR = ACTIONS.map(function (name) {
    return '[data-ccs="' + name + '"]';
  }).join(',');

  function wireNewDesign() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest(ACTION_SELECTOR);
      if (!target) return;
      switch (target.getAttribute('data-ccs')) {
        case 'add-design':  openNewDesign(); break;
        case 'find-style':  window.location.assign(WIZARD_URL); break;
        case 'pick-style':
          // A shirt they have used, with nothing on it yet.
          window.location.assign('/pages/design?style=' +
            encodeURIComponent(target.dataset.handle));
          break;
        case 'edit-default-color':
          editDefaultColor = target.dataset.color;
          renderEditColors();
          break;
        case 'save-listing': saveEdit(target); break;
        case 'close-modal': closeModal(); break;
        default: break;
      }
    });
    document.addEventListener('input', function (event) {
      if (event.target.dataset && event.target.dataset.ccs === 'edit-markup') refreshEditQuote();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  function wireCopyLink() {
    var button = $('[data-ccs="copy-link"]');
    if (!button) return;
    button.addEventListener('click', function () {
      var url = window.location.origin + (state.store ? state.store.shareUrl : '');
      // The async clipboard API is unavailable on insecure origins and in some
      // in-app browsers; falling back keeps the button honest rather than
      // silently doing nothing.
      var done = function () {
        button.textContent = 'Copied';
        setTimeout(function () { button.textContent = 'Copy link'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy your link:', url); });
      } else {
        window.prompt('Copy your link:', url);
      }
    });
  }

  function wireExitImpersonation() {
    var link = $('[data-ccs="exit-impersonation"]');
    if (link) {
      link.addEventListener('click', function () { api.actingAs = null; });
    }
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  function init() {
    root = $('#ccs-dashboard');
    if (!root) return;
    api = window.CCSApi;
    if (root.dataset.loggedIn !== 'true') return;

    readActingAs();
    wireListingActions();
    wireNewDesign();
    wireCopyLink();
    // The strip draws itself and owns the grid's order; the dashboard only
    // has to redraw the grid when it says something moved.
    window.CCSCategories.init({
      api: api,
      grid: $('#ccs-listings'),
      onChanged: function () { renderListings(); }
    });
    wireExitImpersonation();

    var registerForm = $('#ccs-register-form');
    if (registerForm) {
      window.CCSStoreForm.mount(registerForm, {
        onSaved: function (store) {
          renderStore(store);
          mountEditForm(store);
          load();
        }
      });
    }

    load();
  }

  function mountEditForm(store) {
    var editForm = $('#ccs-edit-form');
    if (!editForm || editForm.dataset.mounted) return;
    editForm.dataset.mounted = 'true';

    var warning = $('#ccs-url-warning');
    if (warning) warning.hidden = false;

    window.CCSStoreForm.mount(editForm, {
      store: store,
      onSaved: function (updated, data) {
        renderStore(updated);
        if (data && data.handleChanged) {
          // The vanity link moved. Saying so beats letting them discover it
          // when an old link behaves unexpectedly.
          window.alert('Your store URL is now ' + window.location.host + updated.shareUrl +
            '\n\nYour previous link will still work.');
        }
      }
    });
  }

  function load() {
    api.getStore().then(function (data) {
      renderImpersonation();
      if (data.store) {
        renderStore(data.store);
        mountEditForm(data.store);
        // Before the grid: it asks the strip what to show, so the strip has
        // to know first or the first paint is the wrong tab.
        window.CCSCategories.setData(data);
        renderListings(data.listings);

        /*
         * Sales load separately, and their failure stays in the sales table.
         *
         * This used to be chained onto the same promise, so a sales error
         * landed in the catch below and painted itself over the designs grid
         * that had just rendered successfully -- the seller watched their
         * designs appear and then be replaced by "the server could not be
         * reached". Two unrelated things, one of which had worked.
         */
        api.getSales().then(renderSales).catch(function (error) {
          var table = $('#ccs-sales tbody');
          if (table) {
            table.innerHTML = '<tr><td colspan="9" class="ccs-error">' +
              'Your sales could not be loaded. ' + error.message + '</td></tr>';
          }
        });
        return null;
      }
      // No store: the registration form is already on screen from Liquid, but
      // the metafield may have said otherwise if a previous save half-failed.
      $('#ccs-register').hidden = false;
      $('#ccs-dashboard-body').hidden = true;
    }).catch(function (error) {
      // Only reached when the store itself could not be loaded, in which case
      // there are no designs to show and the message belongs where they would
      // have been.
      var host = $('#ccs-listings');
      if (host) host.innerHTML = '<p class="ccs-error">' + error.message + '</p>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
